document.addEventListener('DOMContentLoaded', function () {
  const filters = document.querySelectorAll('.glossary__attribute-filters-button input');
  const items = document.querySelectorAll('.glossary__item');
  const noItemsMessage = document.querySelector('.glossary__no-items-message');
  let letters = document.querySelectorAll('.glossary__letter');
  function filterItems() {
    // Get active attribute filters
    const activeFilters = Array.from(filters).filter(checkbox => checkbox.checked).map(checkbox => checkbox.value);
    let itemsFound = false;
    items.forEach(item => {
      const itemBenefits = item.getAttribute('data-benefits').split(',');
      const itemTypes = item.getAttribute('data-type').split(',');

      // Check if the item contains the filters in its benefits and type
      const matchesBenefit = activeFilters.some(filter => itemBenefits.includes(filter));
      const matchesType = activeFilters.some(filter => itemTypes.includes(filter));
      const shouldDisplay = activeFilters.length === 0 ? true : matchesBenefit || matchesType;
      item.style.display = shouldDisplay ? 'block' : 'none';
      if (shouldDisplay) {
        itemsFound = true;
      }

      // Keep active letter only the letters with displayed items
      letters.forEach(letter => {
        let letterToCheck = letter.getAttribute('data-letter');
        let itemsToCheck = document.querySelectorAll(`.glossary__item[data-title=${letterToCheck}]`);
        let itemsToCheckFiltered = Array.from(itemsToCheck).filter(item => item.style.display == 'block');
        if (itemsToCheckFiltered.length == 0) {
          letter.classList.add('glossary__letter--is-inactive');
        } else {
          letter.classList.remove('glossary__letter--is-inactive');
        }
      });
    });

    // Show or hide the "no items found" message
    noItemsMessage.style.display = itemsFound ? 'none' : 'block';
  }

  // Event listener for benefits and type
  filters.forEach(filter => {
    filter.addEventListener('change', filterItems);
  });

  // Initial filtering
  filterItems();

  // Collapsible element 
  document.querySelectorAll('.glossary__attribute-filters-title').forEach(title => {
    title.addEventListener('click', function () {
      // Find the corresponding sibling element
      const valuesElement = this.nextElementSibling;

      // Check if the sibling element exists and has the expected class
      if (valuesElement && valuesElement.classList.contains('glossary__attribute-filters-values')) {
        // Toggle the visibility of the sibling element
        valuesElement.classList.toggle('glossary__attribute-filters-values--is-hidden');
      }

      // Toggle the class of the clicked title
      this.classList.toggle('glossary__attribute-filters-title--is-not-expanded');
    });
  });

  // Anchor links
  document.querySelectorAll('.glossary__letter').forEach(letter => {
    letter.addEventListener('click', function () {
      let letter = String(this.textContent).toLowerCase();
      let firstItem = document.querySelector(`.glossary__item[data-title="${letter}"]:not([style="display: none;"])`);
      firstItem.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
  });
});